const completeSetLineItemProperties = {
  '_COMPLETE THE SET': 'COMPLETE THE SET'
};

const bundleLineItemProperties = {
  '_BUNDLE': 'BUNDLE'
};

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const selectedAddOns = getCompleteSetSelections();
      const selectedBundleItems = getBundleSelections();

      try {
        if (selectedBundleItems.length || selectedAddOns.length) {
          this.classList.add('sa-complete-set-add-to-cart-loading');
          this.querySelector('.shopify-payment-button')?.classList.add('sa-complete-set-add-to-cart-loading');

          const quantity = Number(formData.get('quantity') || 1);
          const variantId = Number(formData.get('id'));
          const bundleConfig = fetchConfig('json');
          bundleConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          bundleConfig.body = JSON.stringify({
            items: [
              {
                id: variantId,
                quantity,
                ...(selectedBundleItems.length ? { properties: bundleLineItemProperties } : {})
              },
              ...selectedBundleItems.map((checkbox) => ({
                id: Number(checkbox.value),
                quantity,
                properties: bundleLineItemProperties
              })),
              ...selectedAddOns.map((checkbox) => ({
                id: Number(checkbox.value),
                quantity,
                properties: completeSetLineItemProperties
              }))
            ],
            sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
          });

          const response = await fetch(`${routes.cart_add_url}`, bundleConfig).then((result) => result.json());

          if (response.status) {
            this.handleErrorMessage(response.description);
            this.error = true;
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            this.classList.remove('sa-complete-set-add-to-cart-loading');
            this.querySelector('.shopify-payment-button')?.classList.remove('sa-complete-set-add-to-cart-loading');
            return;
          }

          this.error = false;
          response.key = response.key || response.items?.[0]?.key;
          await applyBundleDiscountCode(selectedBundleItems);

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }

          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.classList.remove('sa-complete-set-add-to-cart-loading');
          this.querySelector('.shopify-payment-button')?.classList.remove('sa-complete-set-add-to-cart-loading');
          return;
        }

        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        delete config.headers['Content-Type'];

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      } catch (e) {
        console.error(e);
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

document.addEventListener('click', async (event) => {
  const paymentButton = event.target.closest('.shopify-payment-button__button');
  if (!paymentButton) return;

  const selectedAddOns = getCompleteSetSelections();
  const selectedBundleItems = getBundleSelections();
  if (!selectedAddOns.length && !selectedBundleItems.length) return;

  const productForm = paymentButton.closest('product-form');
  const form = productForm?.querySelector('form');
  if (!form) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  paymentButton.setAttribute('aria-disabled', true);
  paymentButton.classList.add('loading');

  const formData = new FormData(form);
  const quantity = Number(formData.get('quantity') || 1);
  const variantId = Number(formData.get('id'));
  const checkoutUrl = getCheckoutUrl(getBundleDiscountCode(selectedBundleItems));

  try {
    const config = fetchConfig('json');
    config.body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity,
          ...(selectedBundleItems.length ? { properties: bundleLineItemProperties } : {})
        },
        ...selectedBundleItems.map((checkbox) => ({
          id: Number(checkbox.value),
          quantity,
          properties: bundleLineItemProperties
        })),
        ...selectedAddOns.map((checkbox) => ({
          id: Number(checkbox.value),
          quantity,
          properties: completeSetLineItemProperties
        }))
      ]
    });

    const response = await fetch(`${routes.cart_add_url}`, config).then((result) => result.json());

    if (response.status) {
      productForm?.handleErrorMessage(response.description);
      paymentButton.removeAttribute('aria-disabled');
      paymentButton.classList.remove('loading');
      return;
    }

    window.location.href = checkoutUrl;
  } catch (error) {
    console.error(error);
    paymentButton.removeAttribute('aria-disabled');
    paymentButton.classList.remove('loading');
  }
}, true);

function getCompleteSetSelections() {
  return Array.from(document.querySelectorAll('.sa-complete-set__checkbox:checked:not(:disabled)'));
}

function getBundleSelections() {
  return Array.from(document.querySelectorAll('.sa-bundle__checkbox:checked:not(:disabled)'));
}

function getBundleDiscountCode(selectedBundleItems = getBundleSelections()) {
  const bundle = selectedBundleItems[0]?.closest('.sa-bundle');
  return bundle?.dataset.bundleDiscountCode?.trim() || '';
}

function getCheckoutUrl(discountCode = '') {
  if (!discountCode) return `${window.location.origin}/checkout`;
  return `${window.location.origin}/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent('/checkout')}`;
}

async function applyBundleDiscountCode(selectedBundleItems = getBundleSelections()) {
  const discountCode = getBundleDiscountCode(selectedBundleItems);
  if (!discountCode) return;

  try {
    await fetch(`/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent('/cart')}`, {
      credentials: 'same-origin',
      cache: 'no-store'
    });
  } catch (error) {
    console.error(error);
  }
}

function getProductCheckoutData(paymentContainer) {
  const section = paymentContainer.closest('section') || document;
  const productForm = section.querySelector('product-form');
  const form = productForm?.querySelector('form');

  if (!productForm || !form) return null;

  const formData = new FormData(form);
  return {
    productForm,
    form,
    quantity: Number(formData.get('quantity') || 1),
    variantId: Number(formData.get('id'))
  };
}

async function addCompleteSetToCheckout(paymentContainer, button) {
  const selectedAddOns = getCompleteSetSelections();
  const selectedBundleItems = getBundleSelections();
  const checkoutData = getProductCheckoutData(paymentContainer);

  if ((!selectedAddOns.length && !selectedBundleItems.length) || !checkoutData) return;

  button.setAttribute('aria-disabled', true);
  button.classList.add('loading');

  try {
    const config = fetchConfig('json');
    config.body = JSON.stringify({
      items: [
        {
          id: checkoutData.variantId,
          quantity: checkoutData.quantity,
          ...(selectedBundleItems.length ? { properties: bundleLineItemProperties } : {})
        },
        ...selectedBundleItems.map((checkbox) => ({
          id: Number(checkbox.value),
          quantity: checkoutData.quantity,
          properties: bundleLineItemProperties
        })),
        ...selectedAddOns.map((checkbox) => ({
          id: Number(checkbox.value),
          quantity: checkoutData.quantity,
          properties: completeSetLineItemProperties
        }))
      ]
    });

    const response = await fetch(`${routes.cart_add_url}`, config).then((result) => result.json());

    if (response.status) {
      checkoutData.productForm.handleErrorMessage(response.description);
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      return;
    }

    window.location.href = getCheckoutUrl(getBundleDiscountCode(selectedBundleItems));
  } catch (error) {
    console.error(error);
    button.removeAttribute('aria-disabled');
    button.classList.remove('loading');
  }
}

function syncCompleteSetCheckoutButtons() {
  const hasSelectedAddOns = getCompleteSetSelections().length > 0 || getBundleSelections().length > 0;

  document.querySelectorAll('.shopify-payment-button').forEach((paymentContainer) => {
    let customButton = paymentContainer.querySelector('.sa-complete-set-checkout-button');

    if (!customButton) {
      customButton = document.createElement('button');
      customButton.type = 'button';
      customButton.className = 'sa-complete-set-checkout-button';
      customButton.setAttribute('aria-label', 'Buy selected complete the set products with Shop Pay');
      customButton.addEventListener('click', (event) => {
        event.preventDefault();
        addCompleteSetToCheckout(paymentContainer, customButton);
      });
      paymentContainer.appendChild(customButton);
    }

    paymentContainer.classList.toggle('sa-complete-set-checkout-active', hasSelectedAddOns);
  });
}

document.addEventListener('change', (event) => {
  if (!event.target.matches('.sa-complete-set__checkbox, .sa-bundle__checkbox')) return;
  syncCompleteSetCheckoutButtons();
});

document.addEventListener('DOMContentLoaded', syncCompleteSetCheckoutButtons);
document.addEventListener('shopify:section:load', syncCompleteSetCheckoutButtons);
